import TYPES from '@/modules/shared/types';

// Domain
import { AllianzAccountMovementReportRepository } from '../../domain/repository';
import { MovementEntity } from '../../domain/entities/movement-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';
import {
  SearchMovementDto,
} from '@/modules/my-investment/allianz/allianz-account-movement-report/domain/dtos/search-movement-dto';

@Injectable()
export default class AllianzAccountMovementReportHttpRepository
implements AllianzAccountMovementReportRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/allianz/allianz-account-movement-report/search`;

  execute(search_movement_dto: SearchMovementDto): Promise<Array<MovementEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', search_movement_dto)
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
